import { render, staticRenderFns } from "./ChatMessageText.vue?vue&type=template&id=578cbbfc&scoped=true"
import script from "./ChatMessageText.vue?vue&type=script&lang=js"
export * from "./ChatMessageText.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageText.vue?vue&type=style&index=0&id=578cbbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578cbbfc",
  null
  
)

export default component.exports